// extracted by mini-css-extract-plugin
export default {"dtg-about-footer":"dtg-about-footer_OjoAn","dtg-about-footer__links":"dtg-about-footer__links__TB8f","dtg-about-footer__link":"dtg-about-footer__link_LPyJG"};